import { useMutation, useQuery } from 'react-query';
import * as discussionNoteService from 'services/discussionNoteService';

const getDiscussionNotes = async ({ userId, procedureId, page, pageSize }: {
  userId: number,
  procedureId: number,
  page: number,
  pageSize: number,
}) => {
  return await discussionNoteService.getDiscussionNotes(userId, procedureId, page, pageSize);
}

const addDiscussionNote = async ({ userId, procedureId, note }: {
  userId: number,
  procedureId: number,
  note: string,
}) => {
  return await discussionNoteService.addDiscussionNote(userId, procedureId, note);
}

const updateDiscussionNote = async ({ userId, procedureId, noteId, note }: {
  userId: number,
  procedureId: number,
  noteId: number,
  note: string,
}) => {
  return await discussionNoteService.updateDiscussionNote(userId, procedureId, noteId, note);
}

const deleteDiscussionNote = async ({ userId, procedureId, noteId }: {
  userId: number,
  procedureId: number,
  noteId: number,
}) => {
  return await discussionNoteService.deleteDiscussionNote(userId, procedureId, noteId);
}

export const useGetDiscussionNotes = (userId: number, procedureId: number, page: number, pageSize: number, options = {}) => {
  return useQuery({
    queryKey: ['discussionNotes', userId, procedureId, page, pageSize],
    queryFn: () => getDiscussionNotes({ userId, procedureId, page, pageSize }),
    ...options,
  });
}

export const useAddDiscussionNote = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(addDiscussionNote, {
    onSuccess,
    onError,
    ...options,
  });
}

export const useUpdateDiscussionNote = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(updateDiscussionNote, {
    onSuccess,
    onError,
    ...options,
  });
}

export const useDeleteDiscussionNote = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(deleteDiscussionNote, {
    onSuccess,
    onError,
    ...options,
  });
}
